export default {
  namespaced: true,
  state: {
    show: false,
  },
  mutations: {
    SHOW(state: any) {
      state.show = true;
    },
  },
  actions: {
    show({ commit }: any) {
      commit('SHOW');
    },
  },
};
